import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/chevron-left.svg'


const _hoisted_1 = { class: "login background-white absolute" }
const _hoisted_2 = { class: "flex w-full items-stretch" }
const _hoisted_3 = { class: "form w-full lg:w-2/6 flex flex-col justify-between" }
const _hoisted_4 = { class: "wrap" }
const _hoisted_5 = { class: "text-white font-bold text-3xl flex items-center mb-6" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Lupa Kata Sandi ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-white mb-8 text-sm" }, " Kami akan mengirimkan link ke email yang Anda berikan untuk mengatur ulang kata sandi Anda. Pastikan sebelumnya telah terdaftar sebagai anggota MIISI. ", -1)
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "text-white block mb-2"
}, "Email", -1)
const _hoisted_10 = ["onChange", "onBlur"]
const _hoisted_11 = { class: "invalid-feedback text-red-500 mt-2" }
const _hoisted_12 = { class: "text-center text-white font-semibold text-xs" }

import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import apiUseCase from '@/usecase/apiUseCase'
import ButtonWhite from '@/views/components/button/ButtonWhite.vue'
import HjpAlertModal from '@/views/components/modal/HjpAlertModal.vue'
import ImageSection from '@/views/pages/auth/components/ImageSection.vue'
import CommonHeader from '@/views/pages/auth/components/CommonHeader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const app = getCurrentInstance()
const loading = ref(false)
const router = useRouter()
const version = localStorage.getItem('version')
const isDesktop = ref(window.innerWidth >= 1024)
const { $toast } = app!.appContext.config.globalProperties

// Schema for form validation
const schema = Yup.object().shape({
  email: Yup.string().email('Email tidak valid').required('Email harus diisi'),
})

// Initial values for the form
const initialValues = { email: '' }

// Modal attributes for confirmation
const attrModalConfirmation = reactive({
  show: false,
  title: 'Email Telah Dikirimkan',
  subTitle: '', 
  btnSubmitTitle: 'Cek Email',
  imgContent: require('@/assets/img/icon/success-send-bill.svg'),
  showBtnBack: true,
  showSubmit: false
})

const handleApiError = (response: any) => {
  if (!response) return

  const title = response.title || 'Error occurred'
  let errorMessage = title

  if (response.errors) {
    const errorsArray = Object.values(response.errors).flat()
    errorMessage = `${title}: ${errorsArray.join(', ')}`
  }

  $toast.add({
    severity: 'error',
    detail: errorMessage || 'An unexpected error occurred',
    group: 'br',
    closable: false,
    life: 3000
  })
}
    
// Form submission handler
const onSubmit = async (values: any) => {
  loading.value = true

  try {
    const { error, message } = await apiUseCase.postOrPut('openapi/v1/identity/forgotpassword', null, values)
    console.log(message)
    if (!error) {
      attrModalConfirmation.subTitle = `Email mengatur ulang kata sandi telah dikirimkan ke <b>${values.email}</b>, mohon periksa email untuk mereset kata sandi`
      attrModalConfirmation.show = true
      loading.value = false
    }
  } catch (err: any) {
    const response = err?.response || null  
    console.log('response err =>', response)
    handleApiError(response?.data)
    loading.value = false
  } finally {
      attrModalConfirmation.subTitle = `Email mengatur ulang kata sandi telah dikirimkan ke <b>${values.email}</b>, mohon periksa email untuk mereset kata sandi`
      attrModalConfirmation.show = true
      loading.value = false
  }
}

// Hide dialog function
const hideDialog = () => {
  loading.value = false
  attrModalConfirmation.show = false
}

// Navigation function
const toPage = (val: string) => {
  router.push({ name: val })
}

// Cleanup logic on mount
onMounted(() => {
  localStorage.removeItem('auth')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isDesktop.value)
      ? (_openBlock(), _createBlock(CommonHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      (isDesktop.value)
        ? (_openBlock(), _createBlock(ImageSection, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "mr-4 cursor-pointer",
              alt: "Back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage('Login')))
            }),
            _hoisted_6
          ]),
          _hoisted_7,
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(schema),
            "initial-values": initialValues,
            class: "pb-16 w-full"
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_unref(Field), { name: "email" }, {
                  default: _withCtx(({ field, handleChange, handleBlur }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      onChange: handleChange,
                      onBlur: handleBlur,
                      type: "email",
                      id: "email",
                      placeholder: "Masukkan email terdaftar",
                      class: "input-primary w-full px-4 py-2 rounded-lg bg-white border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                    }), null, 16, _hoisted_10)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_11, _toDisplayString(errors.email), 1)
              ]),
              _createVNode(ButtonWhite, {
                classList: 'btn-size-lg w-full py-3 mt-6 text-lg',
                buttonText: 'Reset Kata Sandi',
                isLoading: loading.value,
                themes: 'primary',
                id: "submit-login",
                type: "submit"
              }, null, 8, ["isLoading"])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(version)), 1)
      ])
    ]),
    _createVNode(HjpAlertModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialog,
      showSubmit: attrModalConfirmation.showSubmit,
      showBtnBack: attrModalConfirmation.showBtnBack,
      onOnSubmit: _cache[1] || (_cache[1] = ($event: any) => (toPage('change-password')))
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "showSubmit", "showBtnBack"])
  ]))
}
}

})